module.exports = __webpack_public_path__ + "45cb148b8af724250f057d905ccebc37.webm";